<template>
  <!--VIP升级-->
  <!--导航栏-->
  <ZhaiHead></ZhaiHead>
  <!--导航栏-->
  <!--九宫格-->
  <div class="container-fluid zhu mb-2">
    <ZhaiJiuGong menu="5"></ZhaiJiuGong>
  </div>
  <!--九宫格-->
  <!--主体-->
  <div class="container-fluid py-2">
    <!--vip明细表-->
    <div class="row shengse">
      <div class="dixian px-3 py-2 d-flex justify-content-between">
        <div>升级VIP</div>
      </div>
      <div class="p-3">
        <div class="jiacu mb-2">
          会员类型和价格
        </div>
        <div class="huiziti pt-2 mb-2">
          <table class="table table-bordered">
            <thead>
            <tr>
              <th scope="col">类型</th>
              <th scope="col">价格</th>
              <th scope="col">查看内容</th>
              <th scope="col">有效期</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in membershipOptions" :key="index">
              <td>{{ item.type }}</td>
              <td>{{ item.price }}元</td>
              <td>{{ item.content }}</td>
              <td>{{ item.duration }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <!--vip明细表-->

        <!--按钮-->
        <div class="G-Btns my-2">
          <button class="btn btn-success membership-btn" @click="selectMembership(membershipOptions[0])">
            <span class="btn-text">月度会员</span><span class="btn-price">188元</span>
          </button>
          <!--                    <button class="btn btn-success membership-btn" @click="selectMembership(membershipOptions[1])">-->
          <!--                        <span class="btn-text">季度会员</span><span class="btn-price">160元</span>-->
          <!--                    </button>-->
          <button class="btn btn-success membership-btn" @click="selectMembership(membershipOptions[1])">
            <span class="btn-text">年度会员</span><span class="btn-price">288元</span>
          </button>
          <button class="btn btn-success membership-btn" @click="selectMembership(membershipOptions[2])">
            <span class="btn-text">永久会员</span><span class="btn-price">500元</span>
          </button>
        </div>
        <!--按钮-->

        <!-- 这个隐藏挂载点只负责让子组件请求补差价数据，不占页面空间 -->
        <div class="banner-probe">
          <VipUpgradeDiffBanner
              ref="vipDiffBanner"
              :user-id="getUser && getUser.id"
              :text-prefix="upgradePrefix"
              @select="handleSelectPermanentUpgrade"
          />
        </div>

        <!-- 只有真正满足补差价条件时，才显示手机端补差价按钮/红条 -->
        <div
            v-if="showUpgradeBanner"
            class="upgrade-diff-banner-wrap"
            @click="triggerBannerClick"
        >
          <div class="upgrade-diff-banner-text">
            {{ fullBannerText }}
          </div>
        </div>

        <!--提醒-->
        <div class="text-primary mt-2 buyinfo">会员升级是通过第三方代收款，商品名称可能不一致，请核对支付金额后放心支付。</div>
        <div class="text-primary mt-3 buyinfo" style="background: #000000;color: #f9ff00!important;">
          支付成功后如果VIP没有生效，请<strong>退出重新登录</strong>，正常情况下支付成功后，30秒内即可完成升级！
          如果重新登录后依然是普通会员，请联系客服邮箱：<strong>yufenglou321@gmail.com</strong>，提供你的<strong>用户名和支付订单详情页截图</strong>，我们将在24小时内为你处理。
        </div>
        <!--提醒-->
      </div>
      <!--升级帮助-->
      <div class="row shengse">
        <div class="dixian px-3 py-2 d-flex justify-content-between">
          <div>升级帮助</div>
        </div>
        <div class="p-3 uphelp" style="font-size:1rem">
          <h1 class="jiacu text-dark">
            充值成功了，为什么还是普通会员?
          </h1>
          <p>
            1、若付款后，仍是普通会员，请<strong>退出并重新登录</strong>即可刷新会员状态。
          </p>
          <!--<p style="font-size:1rem">-->
          <!--2、如果选择天猫直付，付款方式付款成功后，一定要确认收货。确认收货不发货的可发起退款24小时自动退。-->
          <!--</p>-->
          <br>
          <h1 class="jiacu text-dark">
            系统显示正在生成订单，无法显示支付？
          </h1>
          <p>
            由于系统支付订单较多，可能出现无法生成支付订单的情况，请多试几遍不同的支付方式，或过一会再一下。通常这只是暂时性的。
          </p>
          <br>
          <h1 class="jiacu text-dark">
            网站的信息都是真的吗?
          </h1>
          <p>
            本站信息都是全国各地狼友亲自经历后发布的，再由我们网站严格审核后才通过，所以可信度请放心。
            我们每条信息都有一半已显示出来， 肯定有很多你熟悉的地方，每天那么多的信息更新，我们没有你们想象的那么强大，
            可以捏造出这么多虚假信息，同时如果您有顾虑， 可以尝试先购买月度会员，
            你就可以看到信息的联系方式，所以，本站信息是不是真的请你判断，如果你还是认为本站信息是假的， 那么请你离开本站。
          </p>
          <br>
          <h1 class="jiacu text-dark">
            为什么网站有一些信息过时了?
          </h1>
          <p>
            由于行业的特殊性，如果这条信息发布时间半年多了，过时了也正常，但请放心，本站每日大量更新全国信息， 我们也建议你更多关注最新的信息。
          </p>
          <br>
          <h1 class="jiacu text-dark">
            为什么有些信息的联系方式无效？
          </h1>
          <p>
            由于行业的特殊性，楼凤小姐或者商家联系方式更换比较频繁，同时如果这条信息被很多狼友浏览和添加，
            也会导致微信或者QQ联系方式被暂时屏蔽或者直接被封。 如果你无法搜索QQ和微信，这个时候请你尝试一下手机联系方式，
            如果长期没回复或者联系方式失效且无法添加，
            请关注我们同城的其它最新信息即可， 我们每日更新大量全国信息，通过我们的最新信息，总会帮你找到快乐和性福。
          </p>
          <br>
          <h1 class="jiacu text-dark">
            遇到问题，怎样联系客服?
          </h1>
          <p>
            提供你的用户名和支付订单的详情页截图（详情页！！！），我们将在24小时内为你处理。客服邮箱：yufenglou321@gmail.com
          </p>
        </div>
      </div>
      <!--升级帮助-->
    </div>
    <!--主体-->
  </div>
  <!--公共底部-->
  <ZhaiFoot></ZhaiFoot>
  <!--公共底部-->
  <!--升级支付 模态框 -->
  <div class="modal fade" id="upgradeModal" tabindex="-1" aria-labelledby="upgradeModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="upgradeModalLabel">升级支付</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" style="line-height:30px;">
          <div id="step1">
            <div>
              升级VIP目前仅支持支付宝，请确认升级的VIP类型及支付金额是否正确，点击“支付”进行支付。
            </div>
            <div class="mt-2"><strong>升级类型：</strong><span id="uplevel">{{ modalData.type }}</span></div>
            <div class="mt-2"><strong>支付金额：</strong><span id="payamount">{{ modalData.amount }}元</span></div>
            <div class="mt-2">
              <strong>支付方式：</strong>
              <label class="pay-option1">
                <input type="radio" name="paytype" value="2040" v-model="payType" id="alipay">
                {{ alipayOptionText }}
              </label>
              <!--<label class="pay-option">-->
              <!--<input type="radio" name="paytype" value="2080" v-model="payType" id="mobileBank">-->
              <!--手机银行-->
              <!--</label>-->
            </div>
            <div class="mt-2" style="color:red;">
              如果支付加载不出来，多试几次就成功了。
            </div>
            <div class="text-center mt-5 d-flex justify-content-center gap-4">
              <button id="startPayBtn" class="btn btn-success" @click="startPayment">支付</button>
              <button class="btn btn-success" data-bs-dismiss="modal">关闭</button>
            </div>
          </div>
          <div id="step2" style="display:none;">
            <!-- 支付结果提示：直接显示在二维码区域内，不再打开第二个模态框 -->
            <transition name="payment-notice">
              <div
                  v-if="paymentNotice.visible"
                  class="payment-inline-notice"
                  :class="{
                    'payment-inline-success': paymentNotice.type === 'success',
                    'payment-inline-error': paymentNotice.type === 'error'
                  }"
              >
                <i
                    v-if="paymentNotice.type === 'success'"
                    class="bi bi-check-circle-fill payment-notice-icon"
                ></i>
                <i
                    v-else
                    class="bi bi-emoji-frown payment-notice-icon"
                ></i>
                <span>{{ paymentNotice.message }}</span>
              </div>
            </transition>

            <div id="paymsg" style="color: #00c26f;text-align: center;font-size: 1rem;font-weight: bold;"></div>
            <p id="code_msg" style="text-align: center;background: #040404;color: #ffeb00;font-size: 1rem;">
              如页面出现支付步骤文字说明，请务必看完（尤其是付款注意事项）再进行支付。
            </p>
            <p style="text-align: center;font-size: 1rem;color: #000;">
              请确认支付完成后，再点击“支付完成”
            </p>
            <div class="text-center d-flex justify-content-center gap-4">
              <button id="btnpaysucess" class="btn btn-primary" @click="onManualCheckPayment">
                支付完成
              </button>
              <button class="btn btn-primary" data-bs-dismiss="modal">
                关闭
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 时间限制提示模态框 -->
  <div class="modal fade" id="timeRestrictionModal" tabindex="-1" aria-labelledby="timeRestrictionModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" style="max-width: 350px;">
      <div class="modal-content">
        <div class="modal-body d-flex align-items-center justify-content-center">
          <i class="bi bi-clock" style="font-size: 2rem; color: red;"></i>
          <p class="mb-0 ms-2" id="timeRestrictionMessage" style="font-size: 1rem; color: red;"></p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import ZhaiHead from "../components/ZhaiHead";
import ZhaiFoot from "../components/ZhaiFoot";
import ZhaiJiuGong from "../components/ZhaiJiuGong";
import VipUpgradeDiffBanner from "../components/VipUpgradeDiffBanner.vue";
import { Modal } from 'bootstrap';
import QRCode from 'qrcodejs2'; // 引入二维码库
import { mapGetters } from 'vuex';
import http from "../utils/http.js";

export default {
  name: "MUpgradeVIP",
  components: { ZhaiHead, ZhaiFoot, ZhaiJiuGong, VipUpgradeDiffBanner },
  data() {
    return {
      modalData: { type: '', amount: 0 },
      payType: '2040',
      membershipOptions: [
        { type: 'VIP月度会员', price: 188, content: '楼凤', duration: '+1月' },
        // { type: 'VIP季度会员', price: 160, content: '楼凤+暗巷', duration: '+1季度' },
        { type: 'VIP年度会员', price: 288, content: '楼凤+暗巷', duration: '+1年' },
        { type: 'VIP永久会员', price: 500, content: '所有', duration: '永久' }
      ],
      orderId: null,         // 保存生成的订单号，用于手动轮询支付状态
      manualPolling: false,   // 标识是否为手动轮询

      // 二维码区域内的成功/失败提示
      paymentNotice: {
        visible: false,
        type: "",
        message: ""
      },
      paymentNoticeTimer: null,

      showUpgradeBanner: false,
      bannerSyncTimer: null
    };
  },
  computed: {
    ...mapGetters(['getUser']),
    alipayOptionText() {
      // 不再区分月度会员，全部显示“支付宝”
      return '支付宝';
    },

    upgradePrefix() {
      const username = this.getUser?.username || "会员";
      return `尊敬的会员 ${username}：限时补差价 `;
    },

    fullBannerText() {
      const banner = this.$refs.vipDiffBanner;
      if (!banner || !banner.upgradeInfo) return "";

      const username = this.getUser?.username || "会员";
      const price = banner.displayPrice(banner.upgradeInfo.upgradePrice);
      const countdown = banner.countdownText || "";

      return `尊敬的会员 ${username}：限时补差价 ${price}元，即可升级为永久会员！${countdown ? `（剩余${countdown}）` : ""}`;
    }
  },
  methods: {
    startBannerSync() {
      this.stopBannerSync();

      this.bannerSyncTimer = setInterval(() => {
        const banner = this.$refs.vipDiffBanner;
        if (!banner) {
          this.showUpgradeBanner = false;
          return;
        }

        this.showUpgradeBanner = !!banner.visible;
      }, 500);
    },

    stopBannerSync() {
      if (this.bannerSyncTimer) {
        clearInterval(this.bannerSyncTimer);
        this.bannerSyncTimer = null;
      }
    },

    triggerBannerClick() {
      const banner = this.$refs.vipDiffBanner;
      if (banner && typeof banner.handleClick === "function") {
        banner.handleClick();
      }
    },

    handleSelectPermanentUpgrade(payload) {
      this.modalData.type = payload.type;
      this.modalData.amount = payload.amount;
      this.openModal();
    },

    resetPayButton() {
      const payButton = document.getElementById('startPayBtn');
      if (payButton) {
        payButton.textContent = '支付';
        payButton.disabled = false;
      }
    },

    // 显示时间限制提示模态框
    showTimeRestrictionModal(message) {
      document.getElementById('timeRestrictionMessage').innerText = message;
      const timeModal = new Modal(document.getElementById('timeRestrictionModal'));
      timeModal.show();

      // 3秒后自动关闭
      setTimeout(() => {
        timeModal.hide();
      }, 5000);
    },
    selectMembership(item) {
      this.modalData.type = item.type;
      this.modalData.amount = item.price;
      this.openModal();
    },
    openModal() {
      this.hidePaymentNotice();
      this.orderId = null;
      this.manualPolling = false;

      document.getElementById('step1').style.display = 'block';
      document.getElementById('step2').style.display = 'none';

      const paymsg = document.getElementById('paymsg');
      if (paymsg) {
        paymsg.innerHTML = '';
      }

      const modalElement = document.getElementById('upgradeModal');
      const modalInstance = Modal.getOrCreateInstance(modalElement);
      modalInstance.show();
    },

    // 发起支付请求并生成二维码
    startPayment() {
      this.hidePaymentNotice();
      this.orderId = null;
      this.manualPolling = false;

      const payButton = document.getElementById('startPayBtn');
      if (payButton) {
        payButton.textContent = '生成中';
        payButton.disabled = true;
      }

      console.log('用户信息:', this.getUser);

      const { id: userid, username, email } = this.getUser || {};
      if (!userid || !username || !email) {
        this.resetPayButton();
        alert("用户信息不完整，请重新登录！");
        return;
      }

      // 构建后端请求 URL，补差价升级永久会员走专用接口
      let requestUrl = "";
      if (this.modalData.type === "限时补差价升级永久会员") {
        requestUrl = `/platform/frontEndPayment/requestPermanentUpgrade?userid=${userid}&username=${encodeURIComponent(username)}&email=${encodeURIComponent(email)}&paytype=${this.payType}`;
      } else {
        requestUrl = `/platform/frontEndPayment/request?name=${encodeURIComponent(this.modalData.type)}&money=${this.modalData.amount}&userid=${userid}&username=${encodeURIComponent(username)}&email=${encodeURIComponent(email)}&paytype=${this.payType}`;
      }
      // 发送支付请求
      http.get(requestUrl)
          .then(response => {
            const res = response.data;
            console.log('支付接口返回:', res);

            // 按后端实际返回来判断
            if (res && res.status === 1 && res.data) {
              const { payUrl, mchOrderNo } = res.data;
              console.log("payUrl长度=", payUrl.length);
              console.log("payUrl=", payUrl);

              if (!payUrl) {
                this.resetPayButton();
                this.showFailureModal("支付链接为空，请联系管理员！");
                return;
              }

              this.orderId = mchOrderNo;
              this.generateQRCode(payUrl);
            } else {
              this.resetPayButton();
              const errorMessage = res?.msg || '未知错误';
              this.showFailureModal(`支付请求失败：${errorMessage}`);
            }
          })
          .catch(error => {
            this.resetPayButton();
            this.showFailureModal(`请求支付失败，请重试。错误详情: ${error.message}`);
          });
    },

    // 生成二维码并展示在页面上
    generateQRCode(payUrl) {
      console.log("生成二维码的链接:", payUrl);
      document.getElementById('paymsg').innerHTML = '请用手机相机扫描下方二维码，从浏览器打开，将自动跳转支付。';

      // 创建二维码容器
      const qrCodeContainer = document.createElement('div');
      qrCodeContainer.id = 'qrcode';
      qrCodeContainer.style.width = '220px';
      qrCodeContainer.style.height = '220px';
      qrCodeContainer.style.marginTop = '20px';

      document.getElementById('paymsg').appendChild(qrCodeContainer);

      // 生成二维码
      new QRCode(qrCodeContainer, {
        text: payUrl,
        width: 220,
        height: 220,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.L
      });

      document.getElementById('step1').style.display = 'none';
      document.getElementById('step2').style.display = 'block';

      // 设置倒计时时间
      let remainingTime = 300; // 5分钟倒计时（300秒）

      // 添加倒计时显示
      const countdown = document.createElement('p');
      countdown.id = 'countdown';
      countdown.style.textAlign = 'center';
      countdown.style.marginTop = '10px';
      document.getElementById('paymsg').appendChild(countdown);
      countdown.style.fontWeight = "normal";
      countdown.style.color = "rgba(255, 127, 127)";
      countdown.style.fontSize = "0.9rem";

      // 开始倒计时
      const timer = setInterval(() => {
        if (remainingTime <= 0) {
          clearInterval(timer);
          countdown.innerHTML = "支付已超时，请关闭重新选择支付！";
          qrCodeContainer.style.filter = "blur(5px)";
          this.resetPayButton();
        } else {
          const minutes = Math.floor(remainingTime / 60);
          const seconds = remainingTime % 60;
          countdown.innerHTML = `请在 ${minutes}:${seconds < 10 ? '0' + seconds : seconds} 内完成支付`;
          remainingTime--;
        }
      }, 1000);
    },

    // 用户点击支付完成按钮进行手动轮询
    onManualCheckPayment() {
      this.hidePaymentNotice();
      this.manualPolling = true;
      this.checkPaymentStatus();
    },

    // 检查支付状态
    checkPaymentStatus() {
      if (!this.orderId) {
        this.showFailureModal("订单号不存在，请重新发起支付");
        return;
      }

      const statusUrl =
          `/platform/frontEndPayment/checkPaymentStatus?outTradeNo=${encodeURIComponent(this.orderId)}`;

      http.get(statusUrl)
          .then(response => {
            const data = response.data;

            if (data && data.status === 1) {
              this.manualPolling = false;
              this.handlePaymentSuccessStatus();
            } else {
              this.showFailureModal("未检测到支付完成，请稍后重试");
            }
          })
          .catch(error => {
            console.error("查询支付状态异常:", error);
            this.showFailureModal("查询支付状态失败，请稍后重试");
          });
    },

    // 处理支付成功的逻辑
    handlePaymentSuccessStatus() {
      this.$store.dispatch('checkLoginStatus')

      const banner = this.$refs.vipDiffBanner;
      if (banner && typeof banner.refresh === "function") {
        banner.refresh();
      }

      this.showSuccessModal("支付已成功"); // 显示成功提示
    },

    showPaymentNotice(type, message, duration = 3000) {
      if (this.paymentNoticeTimer) {
        clearTimeout(this.paymentNoticeTimer);
        this.paymentNoticeTimer = null;
      }

      this.paymentNotice = {
        visible: true,
        type,
        message
      };

      if (duration > 0) {
        this.paymentNoticeTimer = setTimeout(() => {
          this.hidePaymentNotice();
        }, duration);
      }
    },

    hidePaymentNotice() {
      if (this.paymentNoticeTimer) {
        clearTimeout(this.paymentNoticeTimer);
        this.paymentNoticeTimer = null;
      }

      this.paymentNotice.visible = false;
      this.paymentNotice.type = "";
      this.paymentNotice.message = "";
    },

    // 成功提示直接显示在二维码区域内，2秒后关闭支付框并跳转会员中心
    showSuccessModal(message) {
      this.showPaymentNotice("success", message, 0);

      setTimeout(() => {
        const upgradeElement = document.getElementById("upgradeModal");
        const upgradeModal = Modal.getInstance(upgradeElement);

        if (upgradeModal) {
          upgradeModal.hide();
        }

        this.$router.push("/memberCenter");
      }, 2000);
    },

    // 失败提示直接显示在二维码区域内，二维码和支付框保持不变
    showFailureModal(message) {
      this.showPaymentNotice("error", message, 3000);
    }
  },
  watch: {
    isLoggedIn(val) {
      if (!val) {
        this.$router.push('/login'); // 如果登录状态变为未登录，跳转到登录页面
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    const token = localStorage.getItem('token');
    if (!token) {
      next('/login'); // 如果没有 token，跳转到登录页面
    } else {
      next(); // 否则，继续导航
    }
  },
  mounted() {
    this.startBannerSync();

    setTimeout(() => {
      const loadingModal = document.getElementById('loading');
      if (loadingModal) {
        const modal = new Modal(loadingModal, { keyboard: false });
        modal.hide(); // 隐藏模态框
      }
    }, 8000); // 等待 8 秒后执行，模拟一些延迟操作
  },

  beforeUnmount() {
    this.stopBannerSync();
    this.hidePaymentNotice();
  }
};
</script>

<style scoped>
.table th {
  background-color: #d5d5d5;
  text-align: center;
}

.table td {
  text-align: center;
}

.G-Btns {
  display: flex;
  justify-content: flex-start;
}

.btn-success {
  background-color: #00c26f !important;
  border: none !important;
}

.membership-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 60px;
  text-align: center;
  font-size: 1rem;
  line-height: 1.2;
  padding: 0;
  margin-right: 10px;
}

.btn-text {
  margin-bottom: 2px;
}

.btn-price {
  color: #ffffff;
}

#btnpaysucess,
.modal-body .btn-primary {
  background-color: #00c26f !important;
  border: none !important;
}

.btn {
  margin-right: 10px;
  font-size: 1rem;
}

.btn:last-child {
  margin-right: 0;
}

.buyinfo {
  font-size: 1rem;
  background: #f1f1f1;
  padding: 20px;
  color: red !important;
}

.uphelp h1,
.uphelp p {
  font-size: 1rem;
}

.modal-title {
  font-size: 1rem;
}

.modal-body .btn {
  margin-right: 45px;
}

.modal-body .btn:last-child {
  margin-right: 0;
}

.modal-dialog {
  margin-top: 25%;
}

#upgradeModal .modal-dialog {
  max-width: 400px;
}

#upgradeModal .modal-body {
  line-height: 26px;
  padding: 16px;
}

.zhu {
  margin-top: 80px;
}

#paymsg {
  color: #00c26f;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-size: 0.95rem;
  font-weight: bold;
  line-height: 1.5;
}

#qrcode {
  width: 220px !important;
  height: 220px !important;
  margin: 16px auto 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: filter 0.5s ease;
}

#qrcode img,
#qrcode canvas {
  width: 220px !important;
  height: 220px !important;
  display: block;
}

#countdown {
  font-size: 0.75rem !important;
  color: red !important;
  text-align: center;
  margin-top: 6px !important;
  margin-bottom: 0 !important;
  font-weight: normal !important;
  line-height: 1.2;
}

#code_msg {
  text-align: center;
  background: #040404;
  color: #ffeb00;
  font-size: 0.9rem !important;
  line-height: 1.5;
  padding: 8px 10px;
  margin: 10px auto;
}


.banner-probe {
  position: absolute;
  left: -99999px;
  top: -99999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
  pointer-events: none;
}

.upgrade-diff-banner-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 8px 0 5px;
}

.upgrade-diff-banner-text {
  display: block;
  width: 100%;
  background: #ff2b2b;
  color: #ffffff;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 1.05rem;
  font-weight: 600;
  line-height: 1.6;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
}


.payment-inline-notice {
  width: calc(100% - 20px);
  margin: 0 auto 14px;
  padding: 12px 14px;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
}

.payment-inline-success {
  color: #07894f;
  background-color: #e9fff5;
  border: 1px solid #00c26f;
}

.payment-inline-error {
  color: #dc3545;
  background-color: #fff1f2;
  border: 1px solid #f1aeb5;
}

.payment-notice-icon {
  flex-shrink: 0;
  font-size: 1.35rem;
}

.payment-notice-enter-active,
.payment-notice-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.payment-notice-enter-from,
.payment-notice-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.payment-notice-enter-to,
.payment-notice-leave-from {
  opacity: 1;
  transform: translateY(0);
}

#timeRestrictionModal .modal-dialog {
  margin: 2% auto !important;
  max-width: 350px;
}

.pay-option1 {
  margin-right: 35px;
}

@media (max-width: 767px) {
  .payment-inline-notice {
    width: 100%;
    padding: 10px 12px;
    font-size: 0.9rem;
  }

  #upgradeModal .modal-dialog {
    max-width: 92%;
    margin: 25% auto 0;
  }

  #upgradeModal .modal-body {
    padding: 14px;
  }

  #paymsg {
    font-size: 0.9rem;
  }

  #qrcode {
    width: 200px !important;
    height: 200px !important;
    margin-top: 14px;
  }

  #qrcode img,
  #qrcode canvas {
    width: 200px !important;
    height: 200px !important;
  }

  .modal-body .btn {
    margin-right: 35px;
  }
}
</style>